export default {
	xs: 4,
	s: 8,
	m: 16,
	l: 32,
	xl: 64,
	xxl: 128,
} as const;
